import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import {
  DetailsTour,
  HistoryTours,
  MasterAgreement,
  MyOffers,
  RenterProfileInformation,
  SavedSearch,
  UpcomingTours,
} from 'legacy-pages/pages';
//import { Refferal } from 'components/templates/Refferal/Refferal';
import { TourHistoryTourDetailsPage } from 'components/templates/Landlord/TourHistoryPage/TourHistoryTourDetailsPage/TourHistoryTourDetailsPage';
import { AccountSecurity } from 'components/templates/Renter/AccountSecurity/AccountSecurity';
import IncompleteProfileNavigateGuard from 'guard/navigate-guard/incomplete-profile-navigate-guard';
import { AppRoute } from 'common/enums/route/app-route.enum';

const RenterProfile = lazy(() => import('legacy-pages/renter/profile/renter-profile/renter-profile'));
const ChangePassword = lazy(() => import('legacy-pages/change-password/change-password'));
const ScheduleTour = lazy(() => import('legacy-pages/renter/schedule-tour/schedule-tour'));
const ScheduleTourCheckout = lazy(() => import('legacy-pages/renter/schedule-tour-checkout/schedule-tour-checkout'));
const PreOfferCheckout = lazy(() => import('legacy-pages/renter/pre-offer-checkout/pre-offer-checkout'));
const RenterPaymentPage = lazy(() => import('legacy-pages/RenterPaymentPage/RenterPaymentPage'));
const RenterMasterAgreements = lazy(() => import('legacy-pages/renter/profile/renter-profile/master-agreements/RenterMasterAgreements'));

export const renterRoutes = [
  { path: '', element: <Navigate to='/estates' replace /> },
  {
    path: 'profile',
    element: <RenterProfile />,
    children: [
      { path: '', element: <Navigate to={'info'} replace /> },
      { path: 'info/*', element: <RenterProfileInformation />, index: true },
      { path: 'tours/upcoming', element: <UpcomingTours /> },
      { path: 'tours/history', element: <HistoryTours /> },
      { path: 'saved-search', element: <SavedSearch /> },
      // { path: 'referral', element: <Refferal /> },
      { path: 'security', element: <AccountSecurity /> },
      { path: 'tours/:tourId', element: <DetailsTour /> },
      { path: 'offers', element: <MyOffers /> },
      { path: 'tours/history/:tourId', element: <TourHistoryTourDetailsPage /> },
      { path: 'master-agreements', element: <RenterMasterAgreements /> },
      { path: 'master-agreements/:applicationId', element:
        <IncompleteProfileNavigateGuard navigateRoute={AppRoute.PROFILE_INFO}>
          <MasterAgreement />
        </IncompleteProfileNavigateGuard>
      }
    ],
  },
  { path: 'schedule-tour/:id', element: <ScheduleTour /> },
  { path: 'schedule-tour/checkout/:tourId', element: <ScheduleTourCheckout /> },
  { path: 'offers/pre-application/checkout/:offerId', element: <PreOfferCheckout /> },
  { path: 'change-password', element: <ChangePassword /> },
  { path: 'offers/full-application/checkout/:offerId', element: <RenterPaymentPage /> },
];
